
import React from 'react';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@material-ui/core/Button'

import VerticalStepper from './verticalStepper'
import HorizontalStepper from './horizontalStepper'

const SideBar = (props) => {
    let matches = useMediaQuery('(max-width:767px)')
    if (matches === true){
        return(
            <div className="mt-5 mb-5">
                <div 
                className="row justify-content-center text-center" 
                style={{display: "grid", placeItems: "center"}}>
                    <div className="col mt-5">
                        <h1 style={{fontFamily: 'Nunito', fontSize: "28px", color: "#414042"}}>
                            <strong>We Build expert AI Teams <br/> in 10 Days</strong>
                        </h1>
                    </div>
                </div>
                <div className="col-12">
                <div className="container">
                <div className="row justify-content-around mt-5">
                    <HorizontalStepper stage={props.stage} back={props.back}/>
                </div>
                </div>
                </div>
            </div>
        )
    }
    else
    return (
        <div className="mt-5" style={{borderRight: "2px solid #414042"}}>
                <div 
                className="row justify-content-center text-center" 
                style={{display: "grid", placeItems: "center"}}>
                    <div className="col mt-5">
                        <h1 style={{fontFamily: 'Nunito', fontSize: "28px", color: "#414042"}}>
                            <strong>We Build expert AI Teams in 10 Days</strong>
                        </h1>
                    </div>
                </div>
                <div className="col-12">
                <div className="container">
                <div className="row justify-content-around">
                    <VerticalStepper stage={props.stage}/>
                </div>
                <div className='row'>
                    <Button
                    disabled={props.stage === 0}
                    onClick={props.back}
                    >
                        Back
                    </Button>
                </div>
                </div>
                </div>
        </div>
    );
}
 
export default SideBar;
